import { z } from 'zod';

export const BcmSettingsSchema = z.object({
    id: z.string().optional(),
    settingKey: z.string().min(1),
    settingValue: z.string().optional(),
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateBcmSettingsSchema = BcmSettingsSchema.omit({ id: true });
export const UpdateBcmSettingsSchema = BcmSettingsSchema;